import { render, staticRenderFns } from "./IntegralMonitorRatings.vue?vue&type=template&id=3c6eeffb&scoped=true"
import script from "./IntegralMonitorRatings.vue?vue&type=script&lang=js"
export * from "./IntegralMonitorRatings.vue?vue&type=script&lang=js"
import style0 from "./IntegralMonitorRatings.vue?vue&type=style&index=0&id=3c6eeffb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c6eeffb",
  null
  
)

export default component.exports